import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useInView } from "react-intersection-observer";

export default function About() {
  const { ref, inView } = useInView({
    threshold: 0.3,
    triggerOnce: true,
  });
  
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"]
  });
  
  const imageY = useTransform(scrollYProgress, [0, 1], [-50, 50]);
  const textScale = useTransform(scrollYProgress, [0, 0.5], [0.8, 1]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  return (
    <section className="relative bg-[#F7FBF4] z-20" ref={containerRef} id="about-section">
      <div className="container mx-auto px-4">
      <motion.div
        className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-4 items-center my-10 lg:my-40"
        ref={ref}
        variants={containerVariants}
        initial="hidden"
        animate={inView ? "visible" : "hidden"}
      >
        <motion.div
          className="relative"
          variants={itemVariants}
          style={{ y: imageY }}
        >
          <img
            src="spanish_convo.svg"
            alt="about"
            className="h-[395px] w-full"
            style={{
              objectFit: "contain",
            }}
          />
        </motion.div>
        <motion.div
          className="text-center lg:text-left md:mt-0"
          variants={containerVariants}
          style={{ scale: textScale }}
        >
          <motion.h1
            id="about"
            className="text-[24px] md:text-[36px] lg:text-[45px] font-bold mb-4"
            variants={itemVariants}
          >
            A Personalized Coach In Your Pocket 24/7
          </motion.h1>
          <motion.p
            className="text-[14px] md:text-[18px] leading-10"
            variants={itemVariants}
          >
            Using cutting-edge artificial intelligence, Nudgie will create a
            custom plan to achieve your goal. Then he'll text you every day and
            make sure you get it done.
          </motion.p>
          <br />
          <motion.p
            className="text-[14px] md:text-[18px] leading-10"
            variants={itemVariants}
          >
            Don't even know where to start with your goal? Not sure what habits
            to build, milestones to aim for, or metrics to track? We'll figure
            it out for you.
          </motion.p>
          <br />
          <motion.p
            className="text-[14px] md:text-[18px] leading-10"
            variants={itemVariants}
          >
            Already have a plan and just need a push from a tough coach who
            won't let you off the hook? Nudgie's got you covered too.
          </motion.p>
        </motion.div>
      </motion.div>
    </div>
    </section>
  );
}
